import { render, staticRenderFns } from "./GuanjiaList.vue?vue&type=template&id=6b5679b6&scoped=true"
import script from "./GuanjiaList.vue?vue&type=script&lang=js"
export * from "./GuanjiaList.vue?vue&type=script&lang=js"
import style0 from "./GuanjiaList.vue?vue&type=style&index=0&id=6b5679b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5679b6",
  null
  
)

export default component.exports